import { Provider } from 'react-redux';
import Root from './Root';
import { store } from './redux/store';
import { ThemeProvider } from '@mui/material';
import theme from './theme';
import { I18nextProvider } from 'react-i18next';
import i18n from './lang/i18n';

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <I18nextProvider i18n={i18n}>
          <Root />
        </I18nextProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
